<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div
        class="page-actions"
        style="display: flex; justify-content: space-between"
      >
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input placeholder="主键ID" clearable v-model="id" size="mini">
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="symbolId"
                placeholder="交易对ID"
                clearable
                size="mini"
              >
                <el-option
                  v-for="item in symbolList"
                  :key="item.id"
                  :label="item.symbol"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <el-button
              size="mini"
              type="primary"
              @click="handleSearch({ page: 1 })"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="900">
        <el-table-column label="头像" prop="symbol" />
        <el-table-column label="跟单员名称" prop="takerFee" />
        <el-table-column label="用户UID" prop="takerFee" />
        <el-table-column prop="" label="当前交易员">
          <template slot-scope="scope">
            <span class="buleTxt" @click="showTabBox('newPayer')">aaa</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="累计跟随交易员">
          <template slot-scope="scope">
            <span class="buleTxt" @click="showTabBox('payerLog')">bb</span>
          </template>
        </el-table-column>
        <el-table-column label="累计跟随本金(USDT)" prop="takerFee" />
        <el-table-column label="总胜率" prop="takerFee" />
        <el-table-column label="总权益(USDT)" prop="takerFee" />
        <el-table-column label="盈利笔数/跟单笔数" prop="takerFee" />
        <el-table-column label="创建时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作员" prop="symbol" />
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="show(scope.row)"
              >分析</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="paginationHandle"
      >
      </pagination>

      <el-dialog
        :title="tabModaltitle"
        :visible="dialogVisible1"
        width="800px"
        @close="closeTabBox"
        :destroy-on-close="true"
      >
        <div class="modalSearch">
          <el-input placeholder="搜索UID" clearable v-model="id" size="mini">
          </el-input>
          <el-input
            placeholder="搜索交易员名称"
            clearable
            v-model="id"
            size="mini"
          >
          </el-input>
          <el-select
            v-model="symbolId"
            placeholder="状态"
            clearable
            size="mini"
          >
            <el-option
              v-for="item in statusArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button
            size="mini"
            type="primary"
            @click="getModalData({ page: 1 })"
            >查询</el-button
          >
        </div>
        <el-table :data="modalTabList">
          <el-table-column label="交易员" prop="symbol" />
          <el-table-column label="用户UID" prop="takerFee" />
          <el-table-column label="用户UID" prop="takerFee" />
          <el-table-column prop="" label="状态">
            <template slot-scope="scope"> </template>
          </el-table-column>
          <el-table-column prop="" label="盈利笔数/跟单笔数" />
          <el-table-column label="累计跟单本金" prop="takerFee" />
          <el-table-column label="跟单总交易额" prop="takerFee" />
          <el-table-column label="跟单总盈亏" prop="takerFee" />
          <el-table-column label="更新时间" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.createdTime | moment }}</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :size="modalPagination.size"
          :total="modalTotalCount"
          :page="modalPagination.page"
          @pageChanged="modalPaginationHandle"
        >
        </pagination>
      </el-dialog>

      <el-dialog
        :title="title"
        :visible="dialogVisible"
        width="800px"
        @close="close"
        :destroy-on-close="true"
      >
        <div class="info">
          <el-descriptions class="margin-top" :column="2">
            <el-descriptions-item label="注册时间">{{
              12312312312 | moment
            }}</el-descriptions-item>
            <el-descriptions-item label="开通跟单时间">{{
              12312312312 | moment
            }}</el-descriptions-item>
            <el-descriptions-item label="用户姓名">苏州市</el-descriptions-item>
            <el-descriptions-item label="KYC类型"> </el-descriptions-item>
            <el-descriptions-item label="合约总权益"
              >江苏省苏州市</el-descriptions-item
            >
            <el-descriptions-item label="累计跟随交易员"
              >江苏省苏州市</el-descriptions-item
            >
            <el-descriptions-item label="累计跟随本金"
              >江苏省苏州市</el-descriptions-item
            >
            <el-descriptions-item label="盈利笔数/跟单笔数"
              >江苏省苏州市</el-descriptions-item
            >
            <el-descriptions-item label="总收益" :span="2"
              >江苏省苏州市(去除交易员分润后的净盈亏)</el-descriptions-item
            >
          </el-descriptions>

          <el-tabs v-model="activeTab" @tab-click="handleTabChange">
            <el-tab-pane label="当前跟单" name="aa"></el-tab-pane>
            <el-tab-pane label="历史跟单" name="bb"></el-tab-pane>
            <el-tab-pane label="行为日志" name="cc"></el-tab-pane>
            <el-tab-pane label="跟随交易员" name="dd"></el-tab-pane>
          </el-tabs>
          <el-table :data="modalTabList">
            <template v-if="activeTab == 'aa'">
              <el-table-column label="跟单合约" width="160">
                <template slot-scope="scope">
                  <el-tag>标签一</el-tag>
                  <span>sadasd</span>
                </template>
              </el-table-column>
              <el-table-column label="开仓价" prop="takerFee" />
              <el-table-column label="最新价" prop="takerFee" />
              <el-table-column label="开仓时间" width="160">
                <template slot-scope="scope">
                  <span>{{ scope.row.createdTime | moment }}</span>
                </template>
              </el-table-column>
              <el-table-column label="开仓数量" prop="takerFee" />
              <el-table-column label="保证金" prop="takerFee" />
              <el-table-column prop="" label="未实现盈亏">
                <template slot-scope="scope">
                  <span class="redTxt">{{}}</span>
                  <span class="greenTxt">{{}}</span>
                </template>
              </el-table-column>
            </template>
            <template v-if="activeTab == 'bb'">
              <el-table-column label="跟单合约" width="160">
                <template slot-scope="scope">
                  <el-tag>标签一</el-tag>
                  <span>sadasd</span>
                </template>
              </el-table-column>
              <el-table-column label="开仓价" prop="takerFee" />
              <el-table-column label="平仓价" prop="takerFee" />
              <el-table-column label="开仓时间" width="160">
                <template slot-scope="scope">
                  <span>{{ scope.row.createdTime | moment }}</span>
                </template>
              </el-table-column>
              <el-table-column label="平仓时间" width="160">
                <template slot-scope="scope">
                  <span>{{ scope.row.createdTime | moment }}</span>
                </template>
              </el-table-column>
              <el-table-column label="平仓数量" prop="takerFee" />
              <el-table-column label="保证金" prop="takerFee" />
              <el-table-column prop="" label="平仓盈亏">
                <template slot-scope="scope">
                  <span class="redTxt">{{}}</span>
                  <span class="greenTxt">{{}}</span>
                </template>
              </el-table-column>
            </template>

            <template v-if="activeTab == 'cc'">
              <el-table-column label="日志类型">
                <template slot-scope="scope">
                  <span>sadasd</span>
                </template>
              </el-table-column>
              <el-table-column label="操作时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.createdTime | moment }}</span>
                </template>
              </el-table-column>
            </template>

            <template v-if="activeTab == 'dd'">
              <el-table-column label="交易员" prop="takerFee" />
              <el-table-column label="累计跟随本金" width="160">
                <template slot-scope="scope">
                  <span>{{}}USDt</span>
                </template>
              </el-table-column>
              <el-table-column label="累计跟随收益" width="160">
                <template slot-scope="scope">
                  <span class="redTxt">{{}}USDt</span>
                  <span class="greenTxt">{{}}USDt</span>
                </template>
              </el-table-column>

              <el-table-column label="状态" width="160">
                <template slot-scope="scope">
                  <span>{{}}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <pagination
            :size="modalPagination.size"
            :total="modalTotalCount"
            :page="modalPagination.page"
            @pageChanged="modalPaginationHandle"
          >
          </pagination>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      id: "",
      symbolId: "",
      symbolList: [],
      tabList: [],
      totalCount: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      modalTabList: [],
      modalTotalCount: 0,
      modalPagination: {
        page: 1,
        size: 25,
      },
      dialogVisible: false,
      title: "",
      dialogVisible1: false,
      tabModaltitle: "xx的列表",
      formData: {
        tabData: [],
        title: "",
        info: {},
      },
      statusArr: [
        { label: "全部", value: "" },
        { label: "跟单中", value: "1" },
        { label: "已取消", value: "2" },
      ],
      activeTab: "aa",
    };
  },
  computed: {},
  mounted() {
    api.getSymbolList({ type: "CONTRACT" }).then((res) => {
      if (res.code == 0) {
        this.symbolList = res.data;
      }
    });
    this.handleSearch();
  },
  methods: {
    handleSearch(data = {}) {
      api
        .getSpotSymbolPage({
          id: this.id,
          symbolId: this.symbolId,
          ...this.pagination,
          ...data,
        })
        .then((res) => {
          if (res.code == 0) {
            const { totalCount, list } = res.data;
            this.tabList = list;
            this.totalCount = totalCount;
          }
        });
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.handleSearch();
    },
    show(row) {
      // if (row) {
      //   this.formData = JSON.parse(JSON.stringify(row));
      //   this.formData.createdTime = undefined;
      //   this.formData.updatedTime = undefined;
      // }
      this.formData = { tabData: [], title: "", info: {} };
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
      this.formData = { tabData: [], title: "", info: {} };
    },
    handleSave() {
      if (this.formData.id == "") {
        return this.$message.error("请选择交易对ID");
      }
      api.updateSpotSymbol(this.formData).then((res) => {
        if (res.code == 0) {
          this.$message.success("成功");
          this.close();
          this.handleSearch();
        }
      });
    },

    showTabBox(type) {
      this.dialogVisible1 = true;
      // this.tabModaltitle=''
      this.getModalData();
    },
    getModalData(data = {}) {
      this.handleSearch();
    },
    closeTabBox() {
      this.dialogVisible1 = false;
      this.tabModaltitle = "";
      this.modalTabList = [];
      this.modalTotalCount = 0;
      this.modalPagination = {
        page: 1,
        size: 25,
      };
    },
    modalPaginationHandle(pagination) {
      this.modalPagination = pagination;
      this.getModalData();
    },
    handleTabChange(tab) {
      this.modalTabList = [];
      this.modalTotalCount = 0;
      this.modalPagination = {
        page: 1,
        size: 25,
      };
      this.getCopyModalTabData();
    },
    getCopyModalTabData() {
      console.log("2222", 2222);
      // ...modalPagination
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style scoped lang="less">
.buleTxt {
  color: blue;
  cursor: pointer;
  user-select: none;
}
.modalSearch {
  display: flex;
  gap: 20px;
  .el-input {
    width: 200px;
  }
}
.greenTxt {
  color: #409eff;
}
.redTxt {
  color: red;
}
</style>
